import { createTossBillingAuth, createTossCheckout } from '@platform/billing';
import { getTossBillingPayments, getTossPayments } from '@/shared/libs/toss';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';

const toss = createTossCheckout(getTossPayments);
const tossBilling = createTossBillingAuth(getTossBillingPayments);

interface RequestPaymentParams {
  customerKey: string;
  amount: number;
  /** 서버에 사전 생성한 결제레코드의 orderId. Toss orderId 와 동일해야 함. */
  orderId: string;
  orderName: string;
  customerEmail?: string;
  customerName?: string;
  customerMobilePhone?: string;
}

/**
 * 단건 카드결제 요청 — 미결제 회차 재시도(마이페이지) 전용.
 *
 * 스토어의 신규 구독은 전부 자동결제(requestBillingAuth)를 탄다.
 * 호출 전 서버에 결제(READY) 레코드가 생성돼 있어야 한다(금액 변조 방지).
 */
export function requestCardPayment(
  params: RequestPaymentParams,
): Promise<void> {
  return toss.requestCardPayment({
    ...params,
    successUrl: `${window.location.origin}${PATHS.PAYMENT_SUCCESS}`,
    failUrl: `${window.location.origin}${PATHS.PAYMENT_FAIL}`,
  });
}

interface RequestBillingParams {
  customerKey: string;
  customerEmail?: string;
  customerName?: string;
}

/** 자동결제(빌링) 카드 등록. 돌아올 곳은 반드시 web origin(billing intent 가 여기 있다). */
export function requestBillingAuth(
  params: RequestBillingParams,
): Promise<void> {
  return tossBilling.requestBillingAuth({
    ...params,
    successUrl: `${window.location.origin}${PATHS.PAYMENT_BILLING_SUCCESS}`,
    failUrl: `${window.location.origin}${PATHS.PAYMENT_BILLING_FAIL}`,
  });
}
